module.exports = __webpack_public_path__ + "img/FFBalazs.90970998.jpg";